import { PanelRow } from "@wordpress/components";

const GoogleDrivePicker = ({ setAttributes, clientId, appId, developerKey }) => {
  var scope = ["https://www.googleapis.com/auth/drive.file"];

  if (!clientId || !appId || !developerKey) {
    return <></>;
  }

  var pickerApiLoaded = false;
  var oauthToken;
  function loadPicker() {
    gapi.load("auth", { callback: onAuthApiLoad });
    gapi.load("picker", { callback: onPickerApiLoad });
  }
  function onAuthApiLoad() {
    window.gapi.auth.authorize(
      {
        client_id: clientId,
        scope: scope,
        immediate: false,
      },
      handleAuthResult
    );
  }
  function onPickerApiLoad() {
    pickerApiLoaded = true;
    createPicker();
  }
  function handleAuthResult(authResult) {
    if (authResult && !authResult.error) {
      oauthToken = authResult.access_token;
      createPicker();
    }
  }
  // Create and render a Picker object for searching images.
  function createPicker() {
    if (pickerApiLoaded && oauthToken) {
      var view = new google.picker.View(google.picker.ViewId.DOCS);
      // view.setMimeTypes("image/png,image/jpeg,image/jpg");
      var picker = new google.picker.PickerBuilder()
        .setAppId(appId)
        .setOAuthToken(oauthToken)
        .addView(view)
        .addView(new google.picker.DocsUploadView())
        .setDeveloperKey(developerKey)
        .setCallback(pickerCallback)
        .build();
      picker.setVisible(true);
    }
  }

  // A simple callback implementation.
  function pickerCallback(data) {
    if (data.action == google.picker.Action.PICKED) {
      if (!data.docs?.[0]?.embedUrl) {
        createPicker();
      } else {
        setAttributes({ file: data.docs[0]?.embedUrl });
      }
    }
  }
  return (
    <PanelRow>
      <button onClick={loadPicker} className="drive-picker-button">
        Choose From Google Drive
      </button>
    </PanelRow>
  );
};

export default GoogleDrivePicker;

// import React from 'react'

// const GoogleDrivePicker = () => {
//   return (
//     <div>GoogleDrivePicker</div>
//   )
// }

// export default GoogleDrivePicker
